/* Triki Hengelsport — theme.js */
(function () {
  'use strict';

  var routes = window.themeRoutes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + value;
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var toggles = qsa('[data-mobile-nav-toggle]');
    var nav = qs('[data-mobile-nav]');
    if (!nav) return;
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = nav.hasAttribute('open');
        if (isOpen) { nav.removeAttribute('open'); document.body.style.overflow = ''; }
        else { nav.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
      });
    });
    qsa('[data-mobile-nav-close]', nav).forEach(function (el) {
      el.addEventListener('click', function () { nav.removeAttribute('open'); document.body.style.overflow = ''; });
    });
    qsa('[data-submenu-toggle]', nav).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sublist = document.getElementById(btn.getAttribute('aria-controls'));
        if (!sublist) return;
        sublist.classList.toggle('is-open');
        btn.classList.toggle('is-open');
      });
    });
  }

  /* ---------- Header search toggle (mobile) ---------- */
  function initSearchToggle() {
    var toggle = qs('[data-search-toggle]');
    var panel = qs('[data-search-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      panel.classList.toggle('is-open');
      if (panel.classList.contains('is-open')) {
        var input = qs('input', panel);
        if (input) input.focus();
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  var CartDrawer = {
    el: null,
    init: function () {
      this.el = qs('[data-cart-drawer]');
      if (!this.el) return;
      qsa('[data-cart-drawer-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (btn.getAttribute('data-cart-drawer-open') === 'ajax') e.preventDefault();
          CartDrawer.open();
        });
      });
      qsa('[data-cart-drawer-close]', this.el).forEach(function (el) {
        el.addEventListener('click', function () { CartDrawer.close(); });
      });
      this.el.addEventListener('click', function (e) {
        if (e.target === qs('[data-cart-drawer-overlay]', CartDrawer.el)) CartDrawer.close();
      });
      qsa('[data-cart-remove]', this.el).forEach(this.bindLineEvents);
      qsa('[data-quantity-input]', this.el).forEach(this.bindLineEvents);
    },
    open: function () { if (this.el) { this.el.setAttribute('open', ''); document.body.style.overflow = 'hidden'; } },
    close: function () { if (this.el) { this.el.removeAttribute('open'); document.body.style.overflow = ''; } },
    bindLineEvents: function () {},
    refresh: function () {
      fetch(routes.cart_url + '?section_id=' + (this.el ? this.el.dataset.sectionId : ''))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (!CartDrawer.el) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newContent = doc.querySelector('[data-cart-drawer-content]');
          var oldContent = qs('[data-cart-drawer-content]', CartDrawer.el);
          if (newContent && oldContent) oldContent.innerHTML = newContent.innerHTML;
          CartCount.updateAll();
        });
    }
  };

  var CartCount = {
    updateAll: function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
    }
  };

  /* ---------- AJAX add to cart ---------- */
  function initAddToCartForms() {
    qsa('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = qs('[type="submit"]', form);
        var formData = new FormData(form);
        var body = {};
        formData.forEach(function (v, k) { body[k] = v; });
        body.items = [{ id: formData.get('id'), quantity: formData.get('quantity') || 1 }];

        if (submitBtn) { submitBtn.classList.add('btn--loading'); submitBtn.disabled = true; }

        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: body.items })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (submitBtn) { submitBtn.classList.remove('btn--loading'); submitBtn.disabled = false; }
            if (data.status) {
              var errEl = qs('[data-form-error]', form);
              if (errEl) { errEl.textContent = data.description || 'Er ging iets mis.'; errEl.hidden = false; }
              return;
            }
            CartCount.updateAll();
            if (CartDrawer.el) { CartDrawer.refresh(); CartDrawer.open(); }
            else { window.location.href = routes.cart_url; }
          })
          .catch(function () {
            if (submitBtn) { submitBtn.classList.remove('btn--loading'); submitBtn.disabled = false; }
          });
      });
    });
  }

  /* ---------- Quantity steppers (cart + product) ---------- */
  function initQuantitySteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quantity-change]');
      if (!btn) return;
      var wrapper = btn.closest('.quantity-selector');
      var input = qs('input', wrapper);
      if (!input) return;
      var step = parseInt(input.step || '1', 10);
      var min = parseInt(input.min || '1', 10);
      var value = parseInt(input.value || '1', 10);
      value = btn.dataset.quantityChange === 'plus' ? value + step : Math.max(min, value - step);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    qsa('[data-cart-line-key]').forEach(function (row) {
      var input = qs('[data-quantity-input]', row);
      if (!input) return;
      input.addEventListener('change', function () {
        updateCartLine(row.dataset.cartLineKey, input.value);
      });
    });

    qsa('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var row = btn.closest('[data-cart-line-key]');
        if (row) updateCartLine(row.dataset.cartLineKey, 0);
      });
    });
  }

  function updateCartLine(key, quantity) {
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () {
      if (qs('[data-cart-drawer]')) CartDrawer.refresh();
      else window.location.reload();
    });
  }

  /* ---------- Product gallery ---------- */
  function initProductGallery() {
    qsa('[data-product-gallery]').forEach(function (gallery) {
      var main = qs('[data-gallery-main] img', gallery);
      qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.dataset.fullSrc || thumb.querySelector('img').src;
          qsa('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariantPickers() {
    qsa('[data-variant-picker]').forEach(function (picker) {
      var variants = JSON.parse(picker.dataset.variants || '[]');
      var optionNames = JSON.parse(picker.dataset.optionNames || '[]');
      var priceEl = qs('[data-product-price]', picker.closest('[data-product-form-wrapper]') || document);

      qsa('[data-option-value]', picker).forEach(function (input) {
        input.addEventListener('change', function () {
          var selected = {};
          qsa('[data-option-name]', picker).forEach(function (group) {
            var checked = qs('input:checked', group);
            if (checked) selected[group.dataset.optionName] = checked.value;
          });
          var match = variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === selected[optionNames[i]]; });
          });
          var idInput = qs('[data-variant-id]', picker.closest('[data-product-form-wrapper]'));
          var submitBtn = qs('[data-add-to-cart]', picker.closest('[data-product-form-wrapper]'));
          if (match) {
            if (idInput) idInput.value = match.id;
            if (submitBtn) {
              submitBtn.disabled = !match.available;
              submitBtn.textContent = match.available ? submitBtn.dataset.addLabel : submitBtn.dataset.soldOutLabel;
            }
            if (priceEl && match.price) priceEl.innerHTML = formatMoney(match.price);
          }
        });
      });
    });
  }

  /* ---------- Free shipping bar ---------- */
  function updateFreeShippingBar() {
    var bar = qs('[data-free-shipping-bar]');
    if (!bar) return;
    var threshold = parseFloat(bar.dataset.threshold) * 100;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var fill = qs('[data-free-shipping-fill]', bar);
      var text = qs('[data-free-shipping-text]', bar);
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      if (fill) fill.style.width = pct + '%';
      if (text) {
        if (cart.total_price >= threshold) text.textContent = bar.dataset.reachedText;
        else text.textContent = bar.dataset.progressPrefix + formatMoney(threshold - cart.total_price) + bar.dataset.progressSuffix;
      }
    });
  }

  function initHeroSlideshow() {
    qsa('[data-hero-slideshow]').forEach(function (root) {
      var slides = qsa('[data-hero-slide]', root);
      if (slides.length < 2) return;
      var dots = qsa('[data-hero-dot]', root);
      var current = 0;
      var timer = null;
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplayMs = parseInt(root.dataset.autoplay || '0', 10);

      function goTo(index) {
        index = (index + slides.length) % slides.length;
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = index;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function startAutoplay() {
        if (!autoplayMs || prefersReducedMotion) return;
        stopAutoplay();
        timer = setInterval(next, autoplayMs);
      }
      function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }

      var nextBtn = qs('[data-hero-next]', root);
      var prevBtn = qs('[data-hero-prev]', root);
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); stopAutoplay(); startAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); stopAutoplay(); startAutoplay(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); stopAutoplay(); startAutoplay(); });
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });
  }

  function initHeaderScroll() {
    var header = qs('[data-header]');
    if (!header) return;
    function update() {
      if (window.scrollY > 12) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeroSlideshow();
    initHeaderScroll();
    initMobileNav();
    initSearchToggle();
    CartDrawer.init();
    initAddToCartForms();
    initQuantitySteppers();
    initProductGallery();
    initVariantPickers();
    updateFreeShippingBar();
  });
})();
